import React from 'react';
import { useSite } from '../content/SiteContext';

// Banderas en SVG para que se vean igual en Windows, Mac, Android e iOS
const FlagPY = () => (
  <svg viewBox="0 0 30 18" width="100%" height="100%" preserveAspectRatio="none" aria-hidden="true">
    <rect width="30" height="6" fill="#D52B1E" />
    <rect y="6" width="30" height="6" fill="#FFFFFF" />
    <rect y="12" width="30" height="6" fill="#0038A8" />
    <circle cx="15" cy="9" r="2.3" fill="none" stroke="#0038A8" strokeWidth="0.5" />
    <circle cx="15" cy="9" r="0.8" fill="#FEDF00" />
    <path d="M13.2 9.6a1.9 1.9 0 0 0 3.6 0" fill="none" stroke="#009B3A" strokeWidth="0.45" />
  </svg>
);

const FlagBR = () => (
  <svg viewBox="0 0 30 18" width="100%" height="100%" preserveAspectRatio="none" aria-hidden="true">
    <rect width="30" height="18" fill="#009C3B" />
    <path d="M15 2 L27.5 9 L15 16 L2.5 9 Z" fill="#FFDF00" />
    <circle cx="15" cy="9" r="4" fill="#002776" />
    <path d="M11.1 8.1 C13.5 7.6 16.6 8 18.9 9.7" fill="none" stroke="#FFFFFF" strokeWidth="0.7" />
  </svg>
);

const FlagUS = () => (
  <svg viewBox="0 0 30 18" width="100%" height="100%" preserveAspectRatio="none" aria-hidden="true">
    <rect width="30" height="18" fill="#FFFFFF" />
    {[0, 2, 4, 6, 8, 10, 12].map((i) => (
      <rect key={i} y={(i * 18) / 13} width="30" height={18 / 13} fill="#B22234" />
    ))}
    <rect width="12" height={(18 / 13) * 7} fill="#3C3B6E" />
    {[1.5, 4, 6.5, 9, 11.5].flatMap((y, r) =>
      [1.5, 4.5, 7.5, 10.5].map((x) => (
        <circle key={`${r}-${x}`} cx={r % 2 ? x + 1.5 : x} cy={y * 0.72 + 0.4} r="0.45" fill="#FFFFFF" />
      ))
    )}
  </svg>
);

export const FLAGS = { es: FlagPY, pt: FlagBR, en: FlagUS };

const OPTIONS = [
  { code: 'es', label: 'Español', Flag: FlagPY },
  { code: 'pt', label: 'Português', Flag: FlagBR },
  { code: 'en', label: 'English', Flag: FlagUS },
];

const LanguageSwitcher = ({ className = '' }) => {
  const { lang, setLang } = useSite();

  return (
    <div className={`flex items-center gap-1.5 ${className}`} role="group" aria-label="Idioma / Language">
      {OPTIONS.map(({ code, label, Flag }) => {
        const active = lang === code;
        return (
          <button
            key={code}
            type="button"
            onClick={() => setLang(code)}
            title={label}
            aria-label={label}
            aria-pressed={active}
            className={`block w-8 h-[1.2rem] md:w-9 md:h-[1.35rem] rounded-[3px] overflow-hidden transition-all duration-200 ${
              active
                ? 'ring-2 ring-white shadow-lg shadow-purple-500/40 opacity-100'
                : 'ring-1 ring-white/30 opacity-60 hover:opacity-100 hover:ring-white/70'
            }`}
          >
            <Flag />
          </button>
        );
      })}
    </div>
  );
};

export default LanguageSwitcher;
